<template>
    <div :class="['chat-user-item', { 'chat-user-item--active': active, 'bg': bg }]" style="position:relative;">
        <el-popover
            style="position: absolute;z-index: 99;right:0;top:0;"
            placement="top-start"
            title="客户星标等级"
            width="240"
            trigger="manual"
            v-model="popStar"
        >
          <div slot="reference" :class="'starBox _'+curStar">
            <i  @click.stop="popStar=!popStar" style="font-size: 16px;" :class="curStar<=0?'el-icon-star-off':'el-icon-star-on'">
              <span style="font-size: 12px;">{{curStar>0?texts[curStar-1]:''}}</span>
              <i v-if="curStar>0" class="el-icon-error" @click.stop="curStar=0" style="padding-left:10px;font-size: 14px;"></i>
            </i>
          </div>
          <el-rate
              style="font-size: 8px;"
              v-model="curStar"
              :colors="colors"
              show-text
              :texts="texts"
              @change="popStar=!popStar"
          >
          </el-rate>
        </el-popover>
        <!-- Avatar -->
        <div class="chat__avatar" :class="{ 'chat__avatar--online': online }">

            <el-badge :hidden="true">
                <el-avatar class="message-avatar" :src="avatar"></el-avatar>
            </el-badge>
            <div v-if="type=='private'" class="chat__oline_circle" :class="{ 'chat__oline_circle--online': online }"></div>
        </div>

        <div class="chat__msg">
            <!-- User -->
            <div class="chat__msg-info">
                <div class="user-name nr normal line-1">{{ name }}</div>
                <div class="msg-time xs muted m-l-5">{{ getTime }}</div>
            </div>

            <!-- Message -->
            <div class="chat__msg-content xs">
                <div class="msg-content muted line-1 flex-1" v-html="getMessage"> </div>
            </div>
        </div>

      <!-- 未读消息数目-->
      <div class="unReadContainer">
        <el-badge v-if="unReadCount>0"  :max="99" :hidden="Boolean(isRead)" :value="unReadCount">
        </el-badge>
      </div>

    </div>
</template>


<script>
/**
 * 聊天用户组件
 * 聊天窗口列表固有组件，其宽度可随父容器适应
 * @param {String} avatar 头像
 * @param {String} name 用户昵称
 * @param {String} message 消息内容
 * @param {String} time 消息时间
 * @param {Number} badge 消息数量
 * @param {Boolean} active 活跃
 */
import { timeFormatChat } from '@/utils/date'
import {starThread} from "../../api/app";
export default {
    name: 'ChatUserItem',
    props: {
        star:{
          type: Number,
        },
        type:{
            type:String,
            default:'private'
        },
        thread_id:{
            type:[Number,String],
            default:''
        },
        avatar: {
            type: String,
            default: ''
        },

        name: {
            type: String,
            default: ''
        },

        message: {
            type: String,
            default: ''
        },

        time: {
            type: [String, Number],
            default: ''
        },

        badge: {
            type: Number,
            default: 0
        },

        active: {
            type: Boolean,
            default: true
        },
        online: {
            type: Number,
            default: 0
        },
        isRead: {
            type: [Boolean, Number],
        },
        msgType: {
            type: Number
        },
        unReadCount:{
            type: Number
        },
        bg:{
          type: Boolean
        },
        data:{
            type:Object
        }
    },
    computed: {
        getTime() {
            return this.time ? timeFormatChat(new Date(this.time).getTime()) : ''
        },
        getMessage() {
            switch (this.msgType) {
                case 1: return this.message;//return this.message.replace(/\[em-([a-z_]+)\]/g, `<span class="em em-$1"></span>`)
                case 2: return '图片消息'
                case 3: return '商品消息'
                case 5: return '议价消息'
                case 6: return '自动回复'
                case 7:
                case 8: return this.message.replace(/@(\S+)/g, `@$1`)
                    .replace(/<color=([^>]+)>(.*?)<\/color>/g, '$2');
                case 9: return '优惠券消息'
            }
        },
        imageURL() {
            return this.$store.getters.baseUrl
        }
    },
    data(){
      return {
        keyData:0,
        colors: {1:'gray', 2:'deeppink', 3:'purple',4:'red',5:'#ff6a00'},
        texts:['黑名单','重点关注','需要挖掘','重点售后','重点接待'],
        curStar:this.star,
        popStar:false,
        inited:false,
    }
    },
    mounted(){
        this.$on("readed",(thread_id)=>{
            if(this.data.thread_id==thread_id){
                this.isRead = true;
            }
        })
        if(this.curStar!=this.star&&this.inited==false){
          console.log(this.data);
          this.inited = true;
        }
    },
    watch:{
      curStar(val){
        console.log(val,this.data);
        starThread({star:val,thread_id: this.data.thread_id,kefu_id:this.$net.userInfo.user_id,group_id:this.data.group_id});
      }
    }
}
</script>


<style lang="scss" scoped>
.chat-user-item {
    position: relative;
    display: flex;
    align-items: center;
    padding: 0 10px;
    height: 76px;
    cursor: pointer;
    
    &:hover {
        // background-color: #F5F5F5;
        // box-shadow: inset 0 1px 1px 0 rgba(0, 0, 0, 0.2);
    }
    
    &--active {
        background-color: #f5f5f5;
    }
    
    .chat__avatar {
        display: flex;
        position: relative;
        align-items: center;
        height: 38px;
        margin-right: 10px;
        //opacity: 0.5;
        // &--online {
        //     //opacity: 1;
        // }
      ::v-deep .el-badge__content{
        position: absolute;
        right: 0px;
        bottom: 0px;
        height: 10px;
        width: 10px;
        box-sizing: content-box;
      }

      ::v-deep .el-badge{
        //position: absolute;
        //right: 0px;
        //bottom: 0px;
      }

        ::v-deep .el-badge__content.is-dot {
            height: 10px;
            width: 10px;
            box-sizing: content-box;
        }
        .chat__oline_circle {
            position: absolute;
            right:0;
            bottom:0;
            width:10px;
            height: 10px;
            border-radius: 50px;
            background-color: #e3e3e3;
            &--online {
                background-color: #00ff00;
            }
        }
    }
    

    .chat__msg {
        flex: 1;
        display: flex;
        flex-direction: column;
        height: 38px;
        overflow: hidden;

        &-info {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .user-name {
                flex: 1;
                white-space: nowrap;
                text-overflow: ellipsis;
            }

            .msg-time {
            }
        }

        &-content {
            flex: 1;
            display: flex;
            align-items: center;

            .msg-badge {
                margin-left: auto;
                line-height: 0;
            }
        }
    }

  .unReadContainer{
    position: absolute;
    right: 10px;
    bottom: 10px;
  }
}
.bg{
  //background-color: pink !important;
  animation: bgColor 3s ease;
  animation-iteration-count: infinite;
}
@keyframes bgColor {
  0% {
    background-color: unset ;
  }
  50% {
    background-color: pink ;
  }
}
.starBox{
  padding: 0 2px;
  border-bottom-left-radius: 4px;
  border-top-left-radius: 4px;
  color:#fff;
}
.starBox .el-icon-star-off{
  color:gray;
}
.starBox._1{
  background: gray;
}
.starBox._2{
  background: deeppink !important;
}
.starBox._3{
  background: purple !important;
}
.starBox._4{
  background: red !important;
}
.starBox._5{
  background: #ff6a00 !important;
}
.message-avatar {
  :deep(img){
    width: 100% !important;
  }
}
</style>